export default __webpack_public_path__ + "static/media/no-files.760948b4.jpg";